import Vue from 'vue'
import VueRouter from 'vue-router'

const routes = [{
	path: "/index",
	name: "Index",
	component: () =>
		import("@/views/index.vue")
},{
	path: "/login",
	name: "Login",
	component: () =>
		import("@/views/login.vue")
},{
	path: "/reg",
	name: "Reg",
	component: () =>
		import("@/views/reg.vue")
},{
	path: "/products",
	name: "Products",
	component: () =>
		import("@/views/products.vue")
},{
	path: "/newslist",
	name: "Newslist",
	component: () =>
		import("@/views/newslist.vue")
}, {
	path: "/new/:id",
	name: "New",
	component: () =>
		import("@/views/new.vue")
}, {
        path: "/",
        redirect: "/index" //重定向刚开始的页面
    },];
Vue.use(VueRouter)
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes

})

export default router
